import type { TranslationInterface } from '.';

export const LithuanianLanguage: TranslationInterface = {
  write_a_message_placeholder: 'Parašykite žinutę...',
  your_issue_has_been_resolved: 'Jūsų problema išspręsta!',
  new_conversation: 'Naujas pokalbis',
  welcome_screen_title: 'Sveiki atvykę į mūsų pagalbos pokalbį',
  welcome_screen_description:
    'Mes čia, kad padėtume! Pradėkite pokalbį ir mes atsakysime kuo greičiau.',
  your_name_placeholder: 'Jūsų vardas',
  your_email_placeholder: 'Jūsų el. pašto adresas',
  start_chat_button: 'Kalbėti su pagalba',
  start_chat_button_loading: 'Jungiamasi...',
  i_need_more_help: 'Man reikia daugiau pagalbos',
  this_was_helpful: 'Tai buvo naudinga',
  optional: 'Neprivaloma',
  no_conversations_yet: 'Pokalbių dar nėra',
  back_to_conversations: 'Grįžti į pokalbius',
  closed_conversations: 'Uždaryti pokalbiai',
  csat_title: 'Koks buvo jūsų pokalbis?',
  csat_submitted_title: 'Pokalbį įvertinote kaip',
  csat_feedback_placeholder: 'Papasakokite daugiau... (neprivaloma)',
  follow_up_placeholder: 'Tęsti…',
  companion_layout_label: 'Išdėstymas',
  companion_layout_floating: 'Slankusis',
  companion_layout_sidebar: 'Šoninė juosta',
  companion_layout_fullscreen: 'Visas ekranas',
  companion_close: 'Uždaryti',
  companion_history: 'Pokalbių istorija',
  companion_expand_chat: 'Išplėsti pokalbį',
  companion_sidebar_dock_label: 'Prijungimas',
  companion_sidebar_side_label: 'Pusė',
  companion_sidebar_left: 'Kairė',
  companion_sidebar_right: 'Dešinė',
  companion_resize_chat: 'Keisti pokalbio dydį',
  scroll_to_bottom: 'Slinkti į apačią',
  thinking: 'Galvoju…',
  running: 'Vykdoma…',
  steps: 'žingsniai',
  step_arguments: 'Argumentai',
  step_result: 'Rezultatas',
  attach_files:
    'Pridėti vaizdus, vaizdo įrašus, PDF ar skaičiuokles (didžiausias dydis 25 MB)',
  mark_page_active:
    'Spustelėkite ką nors puslapyje, kad pažymėtumėte — Esc atšaukti',
  mark_page: 'Pažymėkite ką nors puslapyje, kad galėtumėte apie tai paklausti',
  stop_response: 'Stabdyti atsakymą',
  copy_reply: 'Kopijuoti atsakymą',
  mentions_empty: 'Atitikmenų nėra',
  copied: 'Nukopijuota',
  send_message: 'Siųsti žinutę',
  upload_failed: 'Įkelti nepavyko: {error}',
  remove_attachment: 'Pašalinti priedą',
  json_no_items: 'Elementų nėra',
  json_no_data: 'Duomenų nėra',
  json_no_chart_data: 'Diagramai nėra duomenų',
  json_unsupported: 'Nepalaikoma: {type}',
  json_see_less: 'Rodyti mažiau',
  json_phone_agent: 'Telefono agentas',
  json_phone_agent_test: 'Išbandyti internete',
  page_context_remove: 'Pašalinti puslapio kontekstą',
  json_see_more: 'Rodyti dar {count}',
  queued_label: '{count} Eilėje',
  remove_queued_message: 'Pašalinti žinutę iš eilės',
  send_queued_now: 'Išsiųsti eilėje esančias žinutes dabar',
  turn_failed_message: 'Kažkas nutiko ir atsakymas neatėjo.',
  turn_failed_retry: 'Bandyti dar kartą',
  page_mark_hint: 'Spustelėkite ką nors, kad pažymėtumėte',
  page_mark_escape: 'Esc',
  page_mark_shape_box: 'Rėmelis',
  page_mark_shape_circle: 'Apskritimas',
  page_mark_shape_arrow: 'Rodyklė',
  page_mark_shape_bracket: 'Skliaustas',
  page_mark_shape_underline: 'Pabraukimas',
  page_mark_shape_highlight: 'Paryškinimas',
  page_mark_shape_strike_through: 'Perbraukimas',
  page_mark_shape_crossed_off: 'Kryžminis perbraukimas',
  page_mark_shape_aria: 'Žymėjimo forma: {shape}',
  page_mark_note_placeholder: 'Pridėti pastabą… (Enter pridėti)',
  page_mark_attach: 'Pridėti žymėjimą',
  page_mark_remove: 'Pašalinti {label}',
  page_mark_region: 'Pažymėta sritis',
  page_mark_default_message: 'Kas tai?',
  file_rejected: 'Failo tipas nepalaikomas arba failas per didelis.',
  dictate: 'Diktuoti',
  stop_dictation: 'Sustabdyti diktavimą',
  dictation_mic_blocked: 'Leiskite naudoti mikrofoną, kad galėtumėte diktuoti',
  dictation_unavailable: 'Diktavimas šiuo metu nepasiekiamas',
  questions_back: 'Atgal',
  questions_next: 'Toliau',
  questions_send: 'Siųsti',
  questions_type_answer: 'Parašysiu pats',
  questions_answer_placeholder: 'Parašykite savo atsakymą…',
  close_conversation_title: 'Uždaryti pokalbį',
  close_conversation_description: 'Ar tikrai norite uždaryti šį pokalbį?',
  close_conversation_cancel: 'Ne',
  close_conversation_confirm: 'Taip',
  dialog_close: 'Uždaryti',
  zoom_in: 'Priartinti',
  zoom_out: 'Nutolinti',
  reset_zoom: 'Atstatyti mastelį',
  support_chat_aria_label: 'Pagalbos pokalbis',
};
